import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';
import {backupImpersonatorTokens, setTokens} from 'shared/api/auth';

export const impersonate = createAsyncThunk<void, number>(
    'auth/impersonate',
    async(id) => {
        const response = await createHttpRequest({
            method: 'GET',
            path: ApiUrls.IMPERSONATE(id),
            errorMessage: t`Ошибка авторизации`,
        });
        backupImpersonatorTokens();
        setTokens(response.data);

    },
);
